import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './StaticTextPage.module.css'

type StaticTextPageProps = {
  translationPrefixKey: string
  locale: 'en' | 'de'
}

export default class StaticTextPage extends Component<StaticTextPageProps> {
  static async getInitialProps ({
    query: { locale, translationPrefixKey }
  }: {
    query: StaticTextPageProps
  }) {
    return {
      locale,
      disableLinkToHome: true,
      translationPrefixKey
    }
  }

  render () {
    return (
      <article className={styles.root}>
        <header>
          <FormattedMessage
            tagName='h4'
            id={`${this.props.translationPrefixKey}.title`}
          />
          <FormattedMessage
            tagName='p'
            id={`${this.props.translationPrefixKey}.subtitle`}
          />
        </header>
        <FormattedMessage id={`${this.props.translationPrefixKey}.summary`}>
          {txt => (
            <p
              className={styles.summary}
              dangerouslySetInnerHTML={{ __html: txt as any }}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id={`${this.props.translationPrefixKey}.body`}>
          {txt => <section dangerouslySetInnerHTML={{ __html: txt as any }} />}
        </FormattedMessage>
      </article>
    )
  }
}
